import { Badge } from '@startupquickstart/frontend';

interface ThemeStatusBadgeProps {
  status: 'draft' | 'published' | 'needs_review';
}

export function ThemeStatusBadge({ status }: ThemeStatusBadgeProps) {
  const variants: Record<string, 'default' | 'secondary' | 'destructive'> = {
    draft: 'secondary',
    published: 'default',
    needs_review: 'destructive',
  };

  const labels: Record<string, string> = {
    draft: 'Draft',
    published: 'Published',
    needs_review: 'Needs Review',
  };

  return <Badge variant={variants[status]}>{labels[status]}</Badge>;
}
